import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import invariant from '../utils/invariant';

var HeaderAuth =
/*#__PURE__*/
function () {
  /**
   * @constructor
   * @param {string} headerName
   * @param {string} token
   */
  function HeaderAuth(headerName, token) {
    _classCallCheck(this, HeaderAuth);

    invariant(typeof headerName === 'string', 'headerName expected a string, instead received %s.', headerName);
    invariant(typeof token === 'string', 'token expected a string, instead received %s.', token);
    this._headerName = headerName;
    this._token = token;
  }
  /**
   * @param {object} client
   * @returns {any}
   */


  _createClass(HeaderAuth, [{
    key: "authorize",
    value: function authorize(client) {
      var _ref = client.getConfig() || {},
          headers = _ref.headers;

      return client.updateConfig({
        headers: _objectSpread({}, headers, _defineProperty({}, this._headerName, this._token))
      });
    }
  }]);

  return HeaderAuth;
}();
/**
 * @param {string} headerName
 * @returns {HeaderAuthApi}
 */


export function headerAuth(headerName) {
  invariant(typeof headerName === 'string', 'headerName expected a string, instead received %s.', headerName);
  return function (Api) {
    invariant(typeof Api === 'function' && typeof Api.authorize === 'function', 'Api expected a class that has a authorize static method function, instead received %s.', Api);

    var HeaderAuthApi =
    /*#__PURE__*/
    function (_Api) {
      _inherits(HeaderAuthApi, _Api);

      function HeaderAuthApi() {
        _classCallCheck(this, HeaderAuthApi);

        return _possibleConstructorReturn(this, _getPrototypeOf(HeaderAuthApi).apply(this, arguments));
      }

      _createClass(HeaderAuthApi, null, [{
        key: "authorize",

        /**
         * @static
         * @param {string} token
         * @returns {any}
         */
        value: function authorize(token) {
          var auth = new HeaderAuth(headerName, token);
          return Api.authorize(auth);
        }
      }]);

      return HeaderAuthApi;
    }(Api);

    return HeaderAuthApi;
  };
}
export default HeaderAuth;